
<template>
  <div>
    <el-dialog
      title="确认分配"
      :visible.sync="dialogVisible"
      width="1000x"
      top="15px"
      @open="open"
    >
      <el-table ref="multipleTable"
                :data="tableData"
                border
                style="width: 100%;margin-top: 20px"
                show-summary
                :summary-method="getSummaries"
      >
        <el-table-column type="index" width="60" label="序号" align="left" fixed="left" />
        <el-table-column prop="masterContractNum" label="合同号" align="left" />
        <el-table-column prop="deliveryNum" label="分批申请单号" align="left" />
        <el-table-column prop="masterProjectName" label="项目名称" align="left" />
        <el-table-column prop="thisAssign" label="本次分配金额" align="right" width="150" header-align="left" />
      </el-table>
      <div class="footer-btn">
        <el-button type="default" @click="calcel">
          取消
        </el-button>
        <el-button type="primary" :loading="loading" @click="sureSub">
          确认分配
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { assignPartialInvoice } from '@/API/index';
export default {
  data () {
    return {
      dialogVisible: this.dialogdistributionBatch,
      tableData: [],
      loading: false
    };
  },
  props: {
    dialogdistributionBatch: {
      type: Boolean,
      default: false
    },
    tableDataBatchDlaoig: {
      type: Array,
      default: () => { return []; }
    },
    telegraphicTransferNum: {
      type: String,
      default: ''
    }
  },
  components: {

  },
  methods: {
    open () {
      this.tableData = this.tableDataBatchDlaoig;
    },
    // 合并表头
    getSummaries (param) {
      // let allowsum = ['数量', '订单金额', '实际结算金额'];
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '本次分配金额') {
          sums[index] = this.addAssign();
        }
      });
      return sums;
    },
    sureSub () {
      let product = [];
      //  product = JSON.parse(JSON.stringify(this.tableData))
      this.tableData.forEach((item) => {
        product.push({ 'deliveryNum': item.deliveryNum, 'assignAmount': item.thisAssign, 'contractNum': item.masterContractNum });
      });
      let params = {
        'telegraphicTransferNum': this.telegraphicTransferNum,
        'assignParam': product
      };
      this.loading = true;
      assignPartialInvoice(params).then((res) => {
        this.loading = false;
        let json = res.data;
        if (json.status === '200') {
          this.$emit('status', 'freach');
          this.calcel();
        }
      }).catch((res) => {
        this.loading = false;
      });
    },
    addAssign () {
      let cont = 0;
      this.tableData.forEach((item) => {
        cont += item.thisAssign;
      });
      return cont;
    },
    calcel () {
      this.dialogVisible = false;
    }
  },
  watch: {
    dialogdistributionBatch (val) {
      this.dialogVisible = val;
    },
    dialogVisible (val) {
      this.$emit('on-status-dialog', val);
    }
  },
  mounted () {

  }

};
</script>

<style scoped>
.footer-btn{
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>
